import { type FunctionComponent, useCallback, useEffect } from "react"
import { observer } from "mobx-react-lite"
import InfiniteScroll from "react-infinite-scroll-component"
import { Box, Badge, Group, Loader, Flex, SimpleGrid } from "@mantine/core"
import { ErrorResult } from "../../shared/ui/ErrorResult"
import { EmptyResult } from "../../shared/ui/EmptyResult"
import { courseStore } from "../../app/store"
import { CourseService } from "../../app/services"
import { CourseCard } from "./CourseCard"

export const CoursesList = observer(function CoursesList() {
  const { isLoading, error, totalCount, courses } = courseStore

  useEffect(() => {
    void CourseService.load()
  }, [])

  const next = useCallback(() => {
    void CourseService.loadMore()
  }, [])

  const renderInfo = () => {
    if (isLoading) {
      return <ListLoader/>
    }

    if (error) {
      return <ErrorResult errorMessage={error}/>
    }

    if (!courses.length) {
      return <EmptyResult/>
    }

    return (
      <Group position="center">
        <Badge color="gray" size="lg" mt="xl">
          Вы загрузили все курсы
        </Badge>
      </Group>
    )
  }

  return (
    <Box>
      <InfiniteScroll
        next={next}
        dataLength={courses.length}
        hasMore={totalCount !== courses.length}
        loader={<ListLoader/>}
        endMessage={renderInfo()}
      >
        <SimpleGrid
          sx={{
            padding: "8px",
          }}
          spacing={32}
          verticalSpacing={48}
          cols={3}
          breakpoints={[
            { maxWidth: "md", cols: 2, spacing: 24, verticalSpacing: 32 },
            { maxWidth: "sm", cols: 1, verticalSpacing: 24 },
          ]}
        >
          {courses.map((course) => (
            <CourseCard key={course._id} course={course}/>
          ))}
        </SimpleGrid>
      </InfiniteScroll>
    </Box>
  )
})

function ListLoader(): ReturnType<FunctionComponent> {
  return (
    <Flex align="center" justify="center" w="100%" py="md">
      <Loader size="lg" variant="dots"/>
    </Flex>
  )
}
